const workspaceRoutes = new Set([
  "/centro-de-comando", "/growth-team", "/growth-team/teach", "/growth-team/test",
  "/growth-team/rules", "/growth-team/attention", "/growth-team/materials", "/settings/automations",
]);
const aliases = new Set(["/growth", "/hitl-inbox", "/knowledge-base", "/settings/autonomy", "/sdr/settings", "/sdr/sdr-studio", "/journey", "/crm/campaigns", "/account-settings"]);
/** Autonomia da IA inside Espaço da equipe; `/settings/autonomy` redirects here. */
export const TEAM_AUTONOMY_PATH = "/growth-team/rules";
export function isTeamWorkspacePath(pathname: string) { return workspaceRoutes.has(pathname.replace(/\/$/, "")); }
export function isTeamWorkspaceEntry(pathname: string) { return isTeamWorkspacePath(pathname) || aliases.has(pathname.replace(/\/$/, "")); }
export const TEAM_WORKSPACE_TITLES: Record<string, string> = {
  "/growth-team": "Agentes", "/growth-team/teach": "Ensinar", "/growth-team/test": "Testar atendimento",
  "/growth-team/rules": "Autonomia", "/growth-team/attention": "Precisa de você",
  "/growth-team/materials": "Materiais", "/settings/automations": "Copiloto",
};
